module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "loader": "spinner",
      "color": "#36304a",
      "width": 70
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Client User Form")]), _vm._v(" "), _c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n          ")], 1)], 1)], 1), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [_c('div', [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("\n                  Company\n                  "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('multi-select', {
    attrs: {
      "options": _vm.$store.getters['common/getAllMultiClientList'],
      "selected-options": _vm.company_items,
      "placeholder": "Select Company",
      "multiple": true,
      "id": "Company"
    },
    on: {
      "select": _vm.SelectMultiCompany
    },
    model: {
      value: (_vm.clientUserForm.fk_multi_client_id),
      callback: function($$v) {
        _vm.$set(_vm.clientUserForm, "fk_multi_client_id", $$v)
      },
      expression: "clientUserForm.fk_multi_client_id"
    }
  }), _vm._v(" "), (!_vm.clientUserForm.fk_multi_client_id) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.errorList.fk_multi_client_id) + "\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("\n                  Client Name\n                  "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "cu_name",
      "name": "cu_name",
      "placeholder": "Please Enter Client Name",
      "type": "text"
    },
    model: {
      value: (_vm.clientUserForm.cu_name),
      callback: function($$v) {
        _vm.$set(_vm.clientUserForm, "cu_name", $$v)
      },
      expression: "clientUserForm.cu_name"
    }
  }), _vm._v(" "), (!_vm.clientUserForm.cu_name) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.errorList.cu_name) + "\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("\n                  Contact\n                  "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "contact",
      "name": "contact",
      "placeholder": "Please Enter Contact",
      "type": "text"
    },
    model: {
      value: (_vm.clientUserForm.contact),
      callback: function($$v) {
        _vm.$set(_vm.clientUserForm, "contact", $$v)
      },
      expression: "clientUserForm.contact"
    }
  }), _vm._v(" "), (!_vm.clientUserForm.contact) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.errorList.contact) + "\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("\n                  Email\n                  "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "email",
      "name": "email",
      "placeholder": "Please Enter Email ID",
      "type": "text"
    },
    model: {
      value: (_vm.clientUserForm.email),
      callback: function($$v) {
        _vm.$set(_vm.clientUserForm, "email", $$v)
      },
      expression: "clientUserForm.email"
    }
  }), _vm._v(" "), (!_vm.clientUserForm.email) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.errorList.email) + "\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "sm": "8"
    }
  }, [_c('label', [_vm._v("\n                      Password\n                      "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "disabled": _vm.clientUserForm.cu_id ? false : true,
      "formatter": _vm.capitalizeAll,
      "id": "password",
      "name": "password",
      "placeholder": "Please Enter Password",
      "type": "text"
    },
    on: {
      "input": function($event) {
        _vm.PasswordChangeFlag()
      }
    },
    model: {
      value: (_vm.clientUserForm.password),
      callback: function($$v) {
        _vm.$set(_vm.clientUserForm, "password", $$v)
      },
      expression: "clientUserForm.password"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-5",
    attrs: {
      "sm": "4"
    }
  }, [_c('b-button', {
    staticStyle: {
      "font-size": "0.675rem"
    },
    on: {
      "click": _vm.generatePassword
    }
  }, [_vm._v("Generate")])], 1), _vm._v(" "), (!_vm.clientUserForm.password) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                    " + _vm._s(_vm.errorList.password) + "\n                  ")]) : _vm._e()], 1)], 1), _vm._v(" "), (
    _vm.$sessionsStorage.get('designation') == 'Admin' &&
    _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh'
  ) ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("\n                  Prefrence\n                  "), _c('span', {
    staticClass: "error"
  })]), _vm._v(" "), _c('model-list-select', {
    staticClass: "ml-1",
    attrs: {
      "list": _vm.prefrenceList,
      "id": "prefrence",
      "name": "prefrence",
      "option-value": "preVal",
      "option-text": "preText",
      "placeholder": "Select Prefrence"
    },
    model: {
      value: (_vm.clientUserForm.prefrence),
      callback: function($$v) {
        _vm.$set(_vm.clientUserForm, "prefrence", $$v)
      },
      expression: "clientUserForm.prefrence"
    }
  }), _vm._v(" "), (!_vm.clientUserForm.prefrence) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.errorList.prefrence) + "\n                ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("\n                  Address\n                  "), _c('span', {
    staticClass: "error"
  })]), _vm._v(" "), _c('b-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "address",
      "name": "address",
      "type": "text",
      "placeholder": "Please Enter Address"
    },
    model: {
      value: (_vm.clientUserForm.address),
      callback: function($$v) {
        _vm.$set(_vm.clientUserForm, "address", $$v)
      },
      expression: "clientUserForm.address"
    }
  }), _vm._v(" "), (!_vm.clientUserForm.address) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.errorList.address) + "\n                ")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-button', {
    staticClass: "pull-right",
    staticStyle: {
      "margin": "left:5px"
    },
    attrs: {
      "size": "sm",
      "variant": "primary"
    },
    on: {
      "click": _vm.addClientUserForm
    }
  }, [_vm._v("Save")]), _vm._v(" "), (_vm.clientUserForm.cu_id) ? _c('b-button', {
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "variant": "outline-primary",
      "id": "addButtonLoader",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.approveUser(_vm.row2.item)
      }
    }
  }, [_vm._v("Approve")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  })], 1)])], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-370a4ddc","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/clientUserMaster/upsertClientUser.vue
// module id = 2522
// module chunks = 0